interface Route {
  id: string;
  title: string;
  route: string;
  description?: string;
}

interface RoutesMapper {
  title: string;
  routes: Route[];
}

export const routesMapper: RoutesMapper[] = [
  {
    title: 'Broker',
    routes: [
      {
        id: 'broker-purchase',
        title: 'Broker - Purchase',
        route: '/application/broker/purchase',
        description: 'Purchase Assessment Application for the Broker',
      },
      {
        id: 'broker-refinance',
        title: 'Broker - Refinance',
        route: '/application/broker/refinance',
        description: 'Refinance Assessment Application for the Broker',
      },
    ],
  },
  {
    title: 'Credit Analyst',
    routes: [
      {
        id: 'credit-analyst-purchase',
        title: 'Credit Analyst - Purchase',
        route: '/application/credit-analyst/purchase',
        description: 'Purchase Assessment Application for the Credit Analyst',
      },
      {
        id: 'credit-analyst-refinance',
        title: 'Credit Analyst - Refinance',
        route: '/application/credit-analyst/refinance',
        description: 'Refinance Assessment Application for the Credit Analyst',
      },
    ],
  },
  {
    title: 'Online OA',
    routes: [
      {
        id: 'website-oa-purchase',
        title: 'Online OA - Purchase',
        route: '/application/website-oa/purchase',
        description: 'Purchase Assessment Application for the Online OA',
      },
      {
        id: 'website-oa-refinance',
        title: 'Online OA - Refinance',
        route: '/application/website-oa/refinance',
        description: 'Refinance Assessment Application for the Online OA',
      },
    ],
  },
];
